import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { IconComponent } from '../icon/icon.component';
import { IconName } from '../icon/icons';

/** Stato vuoto: icona, titolo, testo e un'azione proiettata. */
@Component({
  selector: 'bs-empty-state',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconComponent],
  host: { class: 'block' },
  template: `
    <div
      class="flex flex-col items-center gap-3 rounded-2xl border border-dashed border-stone-300 px-6 py-10 text-center dark:border-stone-700"
      [attr.data-testid]="testId()"
    >
      <span
        class="inline-flex size-12 items-center justify-center rounded-2xl bg-stone-100 text-stone-600 dark:bg-stone-800 dark:text-stone-300"
      >
        <bs-icon [name]="icon()" />
      </span>
      <h2 class="text-xl font-semibold text-ink dark:text-stone-50">{{ heading() }}</h2>
      @if (text(); as body) {
        <p class="max-w-md text-sm text-stone-600 dark:text-stone-300">{{ body }}</p>
      }
      <div class="mt-2 flex flex-wrap justify-center gap-2"><ng-content /></div>
    </div>
  `,
})
export class EmptyStateComponent {
  readonly icon = input<IconName>('grid');
  readonly heading = input.required<string>();
  readonly text = input<string | null>(null);
  readonly testId = input<string | null>(null);
}
